export function exclusivesRedirectPath(id: string): string {
  const path = `/exclusives?search-EXCLUSIVITY_SETS=${id}`;
  return path;
}